import React, { useEffect, useState } from "react";

// 계정 메뉴 안의 '앱 설치' 한 줄(2026-11-02). 화면 위에 띠로 띄우던 안내를 대표 요청으로 메뉴 안에 숨겼다.
// 크롬·엣지·삼성 인터넷은 브라우저가 주는 설치 창(beforeinstallprompt)을 바로 띄우고,
// 그 창이 없는 아이폰 사파리·앱 안 브라우저는 누르면 방법을 한 줄로 보여 준다.
// 이미 설치한 앱으로 열었으면 줄 자체를 감춘다. 설치 신호는 public/index.html 이 미리 받아 둔다.
const isInstalledApp = () => {
  try {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  } catch (error) {
    return false;
  }
};

const userAgent = () => (window.navigator.userAgent || "").toLowerCase();
const isIphone = () => /iphone|ipad|ipod/.test(userAgent());
const isInAppBrowser = () => /kakaotalk|naver|instagram|fban|fbav|line\//.test(userAgent());

const installGuideText = () => {
  if (isInAppBrowser()) return "크롬이나 사파리로 열면 설치할 수 있어요";
  if (isIphone()) return "공유 → 홈 화면에 추가";
  return "브라우저 메뉴 → 앱 설치";
};

const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="user-menu__install-icon">
    <path
      d="M12 4v11m0 0-4.5-4.5M12 15l4.5-4.5M5 19.5h14"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AppInstallMenuItem = () => {
  const [installPrompt, setInstallPrompt] = useState(() => window.deferredInstallPrompt || null);
  const [isInstalled, setIsInstalled] = useState(isInstalledApp);
  const [isGuideOpen, setIsGuideOpen] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };
    const handleInstalled = () => setIsInstalled(true);
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleInstalled);
    };
  }, []);

  if (isInstalled) return null;

  const handleClick = async () => {
    if (!installPrompt) {
      setIsGuideOpen((previous) => !previous);
      return;
    }
    installPrompt.prompt();
    const choice = await installPrompt.userChoice;
    // 한 번 쓴 신호는 다시 못 쓴다
    window.deferredInstallPrompt = null;
    setInstallPrompt(null);
    if (choice && choice.outcome === "accepted") setIsInstalled(true);
  };

  return (
    <>
      <button type="button" className="user-menu__item user-menu__install" onClick={handleClick}>
        <DownloadIcon />
        앱 설치
      </button>
      {isGuideOpen && <div className="user-menu__install-guide">{installGuideText()}</div>}
    </>
  );
};

export default AppInstallMenuItem;
